module.exports = __webpack_public_path__ + "img/reg.bca9aed6.png";